import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';

/**
 * `reorderAttributeVocabularyValues` request params
 * (what is used to send to server)
 */

export type ReorderAttributeVocabularyValuesRequestOptions = {
	vocabId: number;
	fromValueId: number;
	toValueId: number;
};

/**
 * `reorderAttributeVocabularyValues` request
 * (what gets sent to the server)
 */
export type ReorderAttributeVocabularyValuesRequest = [
	ReorderAttributeVocabularyValuesRequestOptions['vocabId'],
	ReorderAttributeVocabularyValuesRequestOptions['fromValueId'],
	ReorderAttributeVocabularyValuesRequestOptions['toValueId'],
];

/**
 * `reorderAttributeVocabularyValues` response
 * (what comes back from the server)
 */
export type ReorderAttributeVocabularyValuesResponse =
	SuccessResponse<ReorderAttributeVocabularyValuesResult>;

/**
 * `reorderAttributeVocabularyValues` result
 * (what is utilized from the server response)
 */
export type ReorderAttributeVocabularyValuesResult = boolean;

export const reorderAttributeVocabularyValuesEndpoint =
	'reorderAttributeVocabularyValues';

export const reorderAttributeVocabularyValues = async ({
	vocabId,
	fromValueId,
	toValueId,
}: ReorderAttributeVocabularyValuesRequestOptions): Promise<ReorderAttributeVocabularyValuesResult> => {
	const client = NetxQueryClient();

	const requestParams: ReorderAttributeVocabularyValuesRequest = [
		vocabId,
		fromValueId,
		toValueId,
	];

	return client
		.post<ReorderAttributeVocabularyValuesResponse>(
			reorderAttributeVocabularyValuesEndpoint,
			requestParams,
		)
		.then(getResponseResults);
};
